import React, { useState } from "react";
import './circuitMap.css';
import './link.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const CircuitMap = ({ circuits, populateSidePanel }) => {
  const [selectedCircuitId, setSelectedCircuitId] = useState(null);
  const [logoErrors, setLogoErrors] = useState({}); // key: circuitId, value: true/false

  const handleLogoError = (circuitId) => {
    setLogoErrors(prev => ({ ...prev, [circuitId]: true }));
  };

  return (
    <>
      {circuits.map((circuit) => {
        const circuitId = circuit.circuitGmId;
        const circuitVendorId = circuit.circuitVendorId;
        const statusName = circuit.status || "Unknown";
        const linkType = circuit.type?.toLowerCase() || "No Type";
        const handoff = circuit.handoffType || "No-Handoff";
        const logoError = logoErrors[circuitId];

        return (
          
          <div
            className={`circuit-container${selectedCircuitId === circuitId ? " selected" : ""}`}
            key={circuitId}
            onClick={() => {
            setSelectedCircuitId(circuitId);
            populateSidePanel(circuitId);
            }}
          >
          {/* <div
            className={`full-provider`}

          > */}
          <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-${circuitId}`}>
              <span>{`Circuit ID: ${circuitVendorId}`}</span>
            </Tooltip>
          }
        >
            <div className="provider">
              <img
                alt="missing"
                id={`carrierlogo-${circuitId}`}
                src={
                      statusName === "Hold" || statusName === "Cancelled"
                        ? "img/cloud-alpha-red.png"
                        : statusName === "WIP"
                        ? "img/cloud-alpha-orange.png"
                        : statusName === "Unknown"
                        ? "img/cloud-alpha-blue.png"
                        : `img/cloud-alpha-${statusName}.png`
                    }
                    onError={e => { e.target.src = "img/cloud-alpha-blue.png"; }}
                className="provider-background"
              />
              <div className={`status-name ${statusName.toLowerCase()}`}>

                {statusName}
              </div>
              {!logoError ? (
                <img
                  alt={circuit.carrier}
                  src={`img/${circuit.carrier}.png`}
                  className="carrier-logo"
                  onError={() => handleLogoError(circuitId)}
                />
              ) : (
                <div className="carrier-logo" style={{display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold"}}>
                  {circuit.carrier ? circuit.carrier : "No Carrier"}
                </div>
              )}
              <div className="circuit-id">
                {circuitVendorId}
              </div>
              <div className={`link cable link-${handoff.replace(/\s+/g, "-").replace(/\//g, "-")}`} id={`link-${circuitId}`}>
                <div className={`cablelabel label-${linkType}`}> {linkType.toUpperCase()}</div>
                <div className={`handofflabel`}> {handoff.toUpperCase()}</div>
              </div>
              <div className={`router lecrouter`}>
                <img
                  alt="missing"
                  src={`/img/lec-router.png`}
                />
                <div>
                  {circuit.lec}
                </div>
              </div>
              <div id={`gmrouter`} className={`router gmrouter`}>
                <img alt="missing" src={`./img/gm-router.png`} 
                />
              </div>
               
            </div>
            </OverlayTrigger>
              {/* {selectedCircuitId === circuitId && (
                  <span
                    style={{
                      position: "absolute",
                      right: "16px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "2rem",
                      color: "#888"
                    }}
                  >
                    &#8594;
                  </span>
                )} */}
            
          {/* </div> */}
          {/* <div
            style={{
              width: "20%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
           
          </div> */}
        </div>
        );
      })}
    </>
  );
};

export default CircuitMap;